import { create } from 'zustand';
import i18n from 'i18n';
import { AccountsApi, ChangeLimitRequest, RestApiError, StatusCodeEnum } from '@shared/api';

interface UseChangeLimitStore {
  loading: boolean;
  error?: string | null;
  success: boolean | null;
  change: (request: ChangeLimitRequest) => void;
  clear: () => void;
}

export const useChangeLimitStore = create<UseChangeLimitStore>((set) => ({
  loading: false,
  error: null,
  success: null,

  change: async (request: ChangeLimitRequest) => {
    try {
      set({ loading: true, error: null, success: null });
      await AccountsApi.changeLimit(request);
      set({ loading: false, success: true });
      return { loading: false, success: true };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Wrong password';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_BAD_REQUEST:
          if (Array.isArray(restError?.data)) errorMessage = restError?.data?.join('\n');
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, error, success: false });
      return { loading: false, error, success: false };
    }
  },

  clear: () => set({ loading: false, error: null, success: null }),
}));
